module.exports = __webpack_public_path__ + "img/资产负债_试算平衡2.4ed7ecad.png";